import * as React from 'react'

type Props = {
    icon:
        | 'empty-box'
        | 'empty-results'
        | 'feedback-illustrations'
        | 'excellence'
        | 'no-feedback'
        | 'multimedia'
        | 'wave'
        | 'cloud-cross'
    title?: string
    message: string
}

export function Placeholder(props: React.PropsWithChildren<Props>) {
    return (
        <div className="AppCore__ui__Placeholder">
            <div className="AppCore__ui__Placeholder_icon">
                <zaptic-icon icon-name={props.icon} />
            </div>
            {props.title && <div className="AppCore__ui__Placeholder_title">{props.title}</div>}
            <div className="AppCore__ui__Placeholder_message">{props.message}</div>
        </div>
    )
}
